import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { CartContext } from '../context/ShopingCartContext'
import Swal from 'sweetalert2'

const CartWidget = () => {
  const {enviadoAclaracion, setEnviadoAclaracion} = useContext(CartContext); 
  const {enviadoDomicilio, setEnviadoDomicilio} = useContext(CartContext);
  const {enviadoPara, setEnviadoPara} = useContext(CartContext);
  const { cart, setCart } = useContext(CartContext);
  const [cartItems, setCartItems] = useState(cart);
  const [post, setPost] = useState(null)
  const [modifyMode, setModifyMode] = useState(false);
  const baseURL = `${import.meta.env.VITE_IP}/recibo`
  useEffect(() => {
    setCartItems(cart);
  }, [cart]);
  


  const stateCheck = () => {
    const carts = cartItems.map(item => item.cart);
    const index = carts.findIndex(cart => cart !== undefined);
    if (index !== -1) {
      return cartItems[index].cart;
    } else {
      return cartItems;
    }
  };

  const addComment = (productName) => {
    Swal.fire({
      title: `Agregar aclaración para ${productName}`,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: (comment) => {
        const existingCartIndex = cart.findIndex(objeto => Object.keys(objeto).indexOf('cart') !== -1);
        let updatedCart;
        if (existingCartIndex !== -1) {
          // Update cart inside the cart object
          updatedCart = [...cart];
          const existingCart = updatedCart[existingCartIndex];
          const updatedCartItems = existingCart.cart.map(cartItem => {
            if (cartItem.name === productName) {
              let updatedAclaracion = comment;
              if (cartItem.aclaracion) {
                updatedAclaracion = comment;
              }
              return { ...cartItem, especificacion: updatedAclaracion };
            } else {
              return cartItem;
            }
          });
          existingCart.cart = updatedCartItems;
          updatedCart[existingCartIndex] = existingCart;
        } else {
          // Update cartItems array
          updatedCart = cartItems.map(cartItem => {
            if (cartItem.name === productName) {
              let updatedAclaracion = comment;
              if (cartItem.aclaracion) {
                updatedAclaracion = comment;
              }
              return { ...cartItem, especificacion: updatedAclaracion };
            } else {
              return cartItem;
            }
          });
        }
        setCart(updatedCart);
        setCartItems(updatedCart);
      },
      allowOutsideClick: () => !Swal.isLoading()
    });
  };
  
  
  
  const imprimirRecibo = async() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const now = new Date();
    const formattedTime = now.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  if(!isMobile){
    const reciboHTML = `
    <div>
    <style>
      * {
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 12px;
      }
      .recibo {
        border: 1px solid #ccc;
        position: absolute;
        top: 0;
        left: 0;
        margin: 0;
        padding: 10px;
        max-width: 50mm;
      }
      .recibo header {
        text-align: center;
        margin-bottom: 10px;
      }
      .recibo ul.productos {
        list-style: none;
        margin: 0;
        padding: 0;
      }
      .recibo ul.productos li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 3px;
      }
      .recibo .total {
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        margin-top: 5px;
        margin-bottom: 10px;
      }
      .recibo .domicilio {
        margin-top: 10px;
        border-top: 1px solid #ccc;
        padding-top: 5px;
      }
      .recibo .domicilio p {
        margin-bottom: 5px;
      }
    </style>
    <div class="recibo">
      <header>
        <h3>Pedido</h3>
      </header>
      <main>
      <ul class="productos">
      ${cartItems
        .map((item) => {
          let productItem = '';
          if (!item.para && !item.domicilio && !item.aclaracion) {
            item.name == "Gaseosa" ? productItem = `<li>Gaseosas` : item.name == "Adicion" ? productItem = `<li>Adiciones` : productItem = `<li>${item.quantity} ${item.name}`;
            if (item.especificacion) {
              productItem += `<li><b>${item.especificacion}</b></li>`;
            }
            productItem += `</li>`;
          }
          return productItem;
        })
        .join('')}
    </ul>  
        <br />
        <br />
        <p class="total">
          Total: <span class="precio">${getTotal().toLocaleString()}</span>
        </p>
      </main>
      <footer>
        <p>
          <b>Hora:</b> ${formattedTime}
        </p>
        ${cartItems
          .filter((item) => item.para)
          .map(
            (item) =>
              `<p><b>Para:</b> ${item.para.value}</p>`
          )
          .join('')}
      </footer>
      ${cartItems
        .filter((item) => item.domicilio)
        .map(
          (item) =>
            `<div class="domicilio">
              <p><b>Domicilio:</b></p>
              <p>${item.domicilio.message}</p> 
            </div>`
        )
        .join('')}
        ${cartItems
          .filter((item) => item.aclaracion)
          .map(
            (item) =>
              `<div class="domicilio">
                <p><b>Especificaciónes:</b></p>
                <p>${item.aclaracion.message}</p> 
              </div>`
          )
          .join('')}
    </div>
  </div>  
    `;
  
    const ventana = window.open('', '', 'height=500,width=500');
    ventana.document.write(reciboHTML);
    ventana.print();
    ventana.close();
  }
  try {
    const response = await axios.post(baseURL, {
      cartItems: cartItems,
    });
    setPost(response.data);
  } catch (err) {
    console.error(err);
  }
  window.location.reload()
}

  const getTotal = () => {
    let total = 0;
    stateCheck().map((item) => {
      !item.domicilio && !item.para && !item.aclaracion && !item.transferencia ? (total += item.quantity * item.price) : null;
    });
    return total;
  };
  
  const handleModify = () => {
    axios.post(`${import.meta.env.VITE_IP}/modificar`, cartItems)
      .then((response) => {
        console.log(response);
        setModifyMode(false);
        setCart([]);
        window.location.reload()
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const noUser = () => {
    Swal.fire({
      icon: 'warning',
      title: 'Error',
      text: 'Debe ingresar un destinatario antes de facturar',
    });
  }
  const getCartItemCount = () => {
    const cartItems = stateCheck();
    let count = 0;
    cartItems.forEach(item => {
      if (!item.domicilio && !item.para && !item.aclaracion && !item.transferencia) {
        count += 1;
      }
    });
    return count;
  };

  const deleteProduct = (nameDelete) =>{
    const tieneCart = cart.some(objeto => Object.keys(objeto).indexOf('cart') !== -1);
    let verificate = tieneCart ? true : false;
    if(verificate === true){
      const updatedCart = cartItems.map(cartItem => {
        if (cartItem.cart) {
          const updatedCartItems = cartItem.cart.filter(item => item.name !== nameDelete);
          return { ...cartItem, cart: updatedCartItems };
        } else {
          return cartItem;
        }
      });
      
      setCart(updatedCart);
    }else{
      const exist = cartItems.filter((item) => item.name !== nameDelete);
      setCart(exist)
    }
  }


  return (
      <div class="cart-container">
        <a class="cart-icon" href="#">
          <i class="fa fa-shopping-cart">
          <img src="/cart.jpg" alt="Product 1" width='50px'/>
          </i>
          <span class="cart-count">{getCartItemCount()}</span>
        </a>
        <div class="cart-panel">
        {stateCheck().map(item => !item.domicilio & !item.para & !item.aclaracion && !item.transferencia? (<>          <div class="cart-items">
            <div class="cart-item">
              <div class="cart-item-image">
                <img src={item.thumbnail} alt="Product 1" width='50px'/>
              </div>
              <div class="cart-item-details">
                <span class="cart-item-name">{item.name}</span>
                <span class="cart-item-price">{item.price.toLocaleString()} x {item.quantity}</span>
                <button class="deletebuttom" onClick={() => deleteProduct(item.name)}>✖️</button>
                <button class="deletebuttom"onClick={() => addComment(item.name)}>➕</button>
              </div>
            </div>
          </div></>):(<></>),

          )}
        <div class="cart-total">
        Total: $ {getTotal().toLocaleString()}
          </div>
          {!cartItems.some(item => item.para) ? (
          cartItems.some(item => item.cart) ? (
            <button type="button" class="btn btn-warning" onClick={handleModify}>
              Modificar
            </button>
          ) : (
            <button type="button" class="btn btn-success" onClick={noUser}>
              Facturar
            </button>
          )
        ) : (

            <button type="button" onClick={() => imprimirRecibo()} class="btn btn-success">Facturar</button>

        )}
        <button type="button" class="btn btn-danger" onClick={()=>   window.location.reload()}>Nuevo Pedido</button>
        </div>
      </div>

  )
}

export default CartWidget;